import React from 'react';
import { Container, Stack, Typography } from '@mui/material';
import Page from 'src/components/Page';
import CustomButton from 'src/components/Button';
import BlogDetailSectionsTabs from './components/BlogDetailSectionsTabs';

function BlogDetailSections() {
  return (
    <Page title="Dashboard | Blog Detail Sections">
      <Container>
        <Typography variant="h4" gutterBottom>
          Blog Detail Sections
        </Typography>
        <Stack direction="row" justifyContent="end" mb={0.5}>
          <CustomButton
            btnText="Add Section"
            icon="ic:round-create"
            variant="contained"
            color="secondary"
            link="/dashboard/blogs-detail-section/add-section"
          />
        </Stack>
        <BlogDetailSectionsTabs />
      </Container>
    </Page>
  );
}

export default BlogDetailSections;
